import { render, staticRenderFns } from "./session-settings.vue?vue&type=template&id=19db124e&scoped=true&"
import script from "./session-settings.vue?vue&type=script&lang=ts&"
export * from "./session-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19db124e",
  null
  
)

export default component.exports